import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md'
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-xl',
    lg: 'max-w-3xl',
    xl: 'max-w-5xl'
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-296">
      <div className="fixed inset-0 bg-black/50 transition-opacity backdrop-blur-sm" onClick={onClose} data-id="element-297" />

      <div className={`
        relative w-full ${sizeClasses[size]} bg-white rounded-[4px] shadow-xl 
        flex flex-col max-h-[90vh] animate-in fade-in zoom-in-95 duration-200
      `} data-id="element-298">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#dddbda]" data-id="element-299">
          <h2 className="text-xl font-light text-[#080707]" data-id="element-300">{title}</h2>
          <button onClick={onClose} className="p-1 rounded hover:bg-[#f3f2f2] text-[#706e6b] transition-colors" data-id="element-301">
            <X className="w-5 h-5" data-id="element-302" />
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto p-6" data-id="element-303">{children}</div>

        {/* Footer */}
        {footer && <div className="flex items-center justify-end gap-3 px-6 py-3 bg-[#f3f2f2] border-t border-[#dddbda] rounded-b-[4px]" data-id="element-304">
            {footer}
          </div>}
      </div>
    </div>;
}